define('editor/edit/layers/edit/vectorBase',['./layerBase', 'knockout', 'knockout-mapping', 'plugins/http', 'durandal/app', 'jquery', 'no-ui-slider', 'tinycolorpicker'], function (layerBase, ko, komapping, http, app, $, noUiSlider) {
    var viewmodel = function () {
        var self = this;
        
        var moduleId = self.__moduleId__;
        self.base = new layerBase();
        $.extend(self, self.base);
        self.__moduleId__ = moduleId;

        self.fillColour = ko.observable();
        self.strokeColour = ko.observable();
        self.strokeWeight = ko.observable();
        self.selectedStrokeWeight = ko.observableArray([]);
        self.strokeOpacity = ko.observable();
        self.fillOpacity = ko.observable();

        self.activate = function (editorMapId, layer, backToListFunc) {
            self.base.activate(editorMapId, layer, backToListFunc);
            self.editorMapId = editorMapId;
            self.layer = layer;
            self.fillColour(self.layer.state().properties.fillColor() || self.layer.state().properties.color());
            self.strokeColour(self.layer.state().properties.color());
            self.strokeWeight(self.layer.state().properties.weight());
            self.selectedStrokeWeight.push('' + self.layer.state().properties.weight());
            self.strokeOpacity(self.layer.state().properties.opacity() * 100);
            self.fillOpacity(self.layer.state().properties.fillOpacity() * 100);

            self.changes = ko.computed(function () {
                // want to be notified of changes to these properties
                return self.fillColour() +
                    self.strokeColour() +
                    self.selectedStrokeWeight()[0] +
                    self.strokeOpacity() +
                    self.fillOpacity();
            });

            self.changes.subscribe(function () {
                // update layer observables and notify
                self.layer.state().properties.fillColor(self.fillColour());
                self.layer.state().properties.color(self.strokeColour());
                self.layer.state().properties.opacity(self.strokeOpacity() / 100);
                self.layer.state().properties.fillOpacity(self.fillOpacity() / 100);
                self.layer.state().properties.weight(self.selectedStrokeWeight()[0]);
                self.layer.state().properties.stroke(self.selectedStrokeWeight()[0] > 0);

                app.trigger("layers:updated", [self.layer]);
            });
        };

        self.compositionComplete = function () {
            // set up jQuery plugins etc..
            var fillSlider = $('.slider-fill'),
                fillSliderStart = self.fillOpacity(),
                strokeSlider = $('.slider-stroke'),
                strokeSliderStart = self.strokeOpacity(),
                fillColourPickerElement = $('.color-picker-fill'),
                fillColourPicker,
                strokeColourPicker;

            if (fillSlider.length) {
                noUiSlider.create(fillSlider.get(0),
            {
                start: fillSliderStart,
                step: 1,
                tooltips: true,
                    connect: "lower",
                    orientation: "horizontal",
                    range: {
                        'min': 0,
                        'max': 100
                    },
                    serialization: {
                        format: {
                            decimals: 0
                        }
                    }
                });
                
                fillSlider.get(0).noUiSlider.on('change', function () {
                    var newValue = fillSlider.get(0).noUiSlider.get();
                    self.fillOpacity(newValue);
                });
            }

            if (strokeSlider.length) {
                noUiSlider.create(strokeSlider.get(0),
            {
                start: strokeSliderStart,
                step: 1,
                tooltips: true,
                    connect: "lower",
                    orientation: "horizontal",
                    range: {
                        'min': 0,
                        'max': 100
                    },
                    serialization: {
                        format: {
                            decimals: 0
                        }
                    }
                });

                strokeSlider.get(0).noUiSlider.on('change', function () {
                    var newValue = strokeSlider.get(0).noUiSlider.get();
                    self.strokeOpacity(newValue);
                });
            }

            strokeColourPicker = $('.color-picker-stroke').tinycolorpicker();
            strokeColourPicker.data().plugin_tinycolorpicker.setColor(self.strokeColour());
            strokeColourPicker.bind("change", function () {
                var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                self.strokeColour(newColour);
            });

            if (fillColourPickerElement.length) {
                fillColourPicker = $('.color-picker-fill').tinycolorpicker();
                fillColourPicker.data().plugin_tinycolorpicker.setColor(self.layer.state().properties.fillColor() || self.layer.state().properties.color());
                fillColourPicker.bind("change", function () {
                    var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                    self.fillColour(newColour);
                });
            }
        };
    };

    return viewmodel;
});

